import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Box } from "@mui/material";

const AbstractBackground = ({ animate, containerRef }) => {
  const numCurves = 20;
  const height = 800;

  // Define a set of soft pastel colors to create a gradient-like effect
  const colors = useMemo(() => ["#BA55D3", "#20B2AA"], []);

  const generateCurves = useCallback((width) => {
    return [...Array(numCurves)].map((_, i) => ({
      d: `M 0,${(i / numCurves) * height} Q ${width / 2 + (Math.random() * width) / 4},${Math.random() * height} ${width},${(i / numCurves) * height}`,
      stroke: colors[i % colors.length],
      strokeOpacity: 0.02 + Math.random() * 0.05,
      strokeWidth: 700 + Math.random() * 3,
    }));
  }, [numCurves, height, colors]);

  const [curves, setCurves] = useState([]);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.offsetWidth;
      setWidth(containerWidth);
      setCurves(generateCurves(containerWidth));
    }
  }, [containerRef, generateCurves]);

  useEffect(() => {
    if (animate && width > 0) {
      const newCurves = generateCurves(width);
      setCurves(newCurves);
    }
  }, [animate, width, generateCurves]);

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
        zIndex: -1,
        background: "#FFFFFF", // White background
      }}
    >
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${width} ${height}`}
      >
        {curves.map((curve, i) => (
          <path
            key={i}
            d={curve.d}
            stroke={curve.stroke} // Cycles through colors
            strokeOpacity={curve.strokeOpacity} // Subtle blending
            strokeWidth={curve.strokeWidth}
            fill="transparent"
            style={{
              transition: "d 1s ease-in-out, stroke-opacity 1s ease-in-out",
            }}
          />
        ))}
      </svg>
    </Box>
  );
};

export default AbstractBackground;